var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-loading',{attrs:{"active":_vm.loading,"can-cancel":false,"opacity":_vm.opacity,"translate":"fade","blur":"3px","is-full-page":_vm.isFullPage}})}
var staticRenderFns = []

export { render, staticRenderFns }